
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"18","viewBox":"0 0 30 18","width":"30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M1.936 1.166L.006 2.332 0 6.442c0 2.588.027 4.333.074 4.717.161 1.314.645 2.655 1.298 3.565.578.808 1.566 1.644 2.494 2.109.545.276 1.567.6 2.212.694.733.108 2.24.094 2.932-.027 1.5-.27 2.67-.85 3.704-1.84.875-.842 1.406-1.691 1.769-2.837.403-1.28.397-1.172.423-7.244L14.933 0l-.161.088c-.094.047-.968.572-1.957 1.165l-1.788 1.079v3.807c0 2.311-.027 4.043-.074 4.414-.242 2-1.338 3.315-2.965 3.537-1.91.27-3.43-.856-3.934-2.897-.107-.465-.12-.95-.154-5.85L3.866.008zM16.2 8.733v8.734l1.944-1.16 1.938-1.167.02-1.254.013-1.248 1.945-.04c2.079-.04 2.835-.122 3.895-.425 1.195-.344 2.14-.89 2.801-1.626.433-.485.892-1.409 1.094-2.212.142-.54.155-.762.149-2.023 0-1.301-.014-1.47-.176-2.063-.628-2.314-2.08-3.52-4.88-4.053-.69-.129-1.034-.142-4.74-.169L16.2 0zm7.817-5.192c1.29.33 1.884.998 2.005 2.245.108 1.039-.263 2.307-.79 2.752-.634.54-1.167.64-3.375.64h-1.742V3.365l1.742.034c1.303.02 1.843.054 2.16.142z"}})])])
          )
        }
      }
    